import { E_NotificationCategories } from '@/ts/enums/E_NotificationCategories';
import { T_NotificationCategoryPreferences } from '@/ts/types/T_NotificationPreferences';
import { T_NotificationUnreadCounts } from '@/ts/types/T_NotificationUnreadCounts';

export const C_DEFAULT_NOTIFICATION_PREFERENCES: T_NotificationCategoryPreferences =
  {
    [E_NotificationCategories.PLATFORM_UPDATES]: false,
    [E_NotificationCategories.ACTIVITY]: false,
    [E_NotificationCategories.ANNOUNCEMENTS]: false
  };

export const C_DEFAULT_NOTIFICATION_COUNTS: T_NotificationUnreadCounts = {
  categories: {
    [E_NotificationCategories.PLATFORM_UPDATES]: 0,
    [E_NotificationCategories.ACTIVITY]: 0,
    [E_NotificationCategories.ANNOUNCEMENTS]: 0
  },
  total: 0
};
